export const TEXT_COLOR = 'var(--trellis-color-text-core-default)';
export const LINE_COLOR = 'var(--trellis-color-fill-field-default)';
export const LINE_COLOR_DARK = 'var(--trellis-color-icon-core-subtle)';
export const TEXT_INACTIVE = 'var(--trellis-color-border-core-default)';
export const BATTLESHIP_TRANSPARENT = 'rgba(203, 214, 226, 0.6)';
export const TOOLTIP_BACKGROUND_COLOR = 'var(--trellis-color-fill-surface-default)';
export const ColorSeries = {
  DEFAULT: ['var(--breeze-data-viz-1)', 'var(--breeze-data-viz-2)', 'var(--breeze-data-viz-3)', 'var(--breeze-data-viz-4)', 'var(--breeze-data-viz-5)', 'var(--breeze-data-viz-6)', 'var(--breeze-data-viz-7)', 'var(--breeze-data-viz-8)']
};